export default __webpack_public_path__ + "static/media/2-5-2.b79b450e.jpg";